<template>
  <VForms
    v-if="visitTypeList"
    :initial-values="initialValues"
    :validation-schema="validations"
    @submit="handleSubmit"
  >
    <template slot-scope="props">
      <form
        class="appointment-form"
        @reset.prevent="props.handleReset"
        @submit.prevent="props.handleSubmit"
      >
        <v-container
          grid-list-md
          align-center
          fill-height
        >
          <v-layout column>
            <v-layout
              column
              fill-height
            >
              <AppointmentForm
                :form="props"
                @updateVisitTimes="updateVisitTimes(props.values.visitType, props.values.date)"
                @isFormValid="isFormValid"
              />
            </v-layout>
            <StepperButtons
              :change-step="changeStep"
              :active="active"
              :number-of-steps="numberOfSteps"
              :form="props"
              :disable-submit="!valid"
            />
          </v-layout>
        </v-container>
      </form>
    </template>
  </VForms>
</template>

<script>
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'
import { Form as VForms } from '@v-forms/core'
import { mapState, mapActions } from 'vuex'
import {
  ACTION_GET_VISIT_TYPES,
  ACTION_GET_VISIT_TIMES,
  ACTION_GET_DEFAULT_INSTITUTION,
  INSTITUTION_KEY,
  VISIT_TYPE_LIST_KEY,
  ACTION_BOOK_APPOINTMENT,
  BOOK_RESULT_KEY,
} from '../../../store/types/appointment.types'
import { SELECTED_PET_KEY } from '../../../store/types/pets.types'
import StepperButtons from '../StepperButtons'
import AppointmentForm from './AppointmentForm'

export default {
  name: 'AppointmentStep',
  components: {
    StepperButtons,
    AppointmentForm,
    VForms,
  },
  props: {
    active: {
      type: Number,
      required: true,
    },
    changeStep: {
      type: Function,
      required: true,
    },
    numberOfSteps: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      validations: {
        visitType: { required },
        date: { required },
      },
      valid: false,
    }
  },
  computed: {
    initialValues() {
      const [visitType] = this.visitTypeList
      return {
        visitType: visitType.id,
        visitTime: undefined,
        date: moment().format('YYYY-MM-DD'),
        description: '',
      }
    },
    ...mapState({
      pet: state => state.pets[SELECTED_PET_KEY],
      bookResult: state => state.appointment[BOOK_RESULT_KEY],
      institution: state => state.appointment[INSTITUTION_KEY],
      visitTypeList: state => state.appointment[VISIT_TYPE_LIST_KEY],
    }),
  },
  watch: {
    institution() {
      if (this.institution && this.visitTypeList) this.getInitialVisitTimes()
    },
    visitTypeList() {
      if (this.visitTypeList && this.institution) this.getInitialVisitTimes()
    },
  },
  mounted() {
    this.getInstitution()
    this.getVisitTypes()
  },
  methods: {
    handleSubmit(values, actions) {
      const data = {
        pet: this.pet,
        appointmentDateFrom: moment(`${values.date} ${values.visitTime}`, 'YYYY-MM-DD HH:mm'),
        appointmentType: values.visitType,
        address: this.institution.addresses[0].id,
        description: values.description,
      }
      this.bookAppointment(data)
      actions.setSubmitting(false)
      if (this.bookResult === true) this.changeStep(this.active + 1)
      this.changeStep(this.active + 1)
    },
    getInitialVisitTimes() {
      const data = {
        type: this.visitTypeList[0].id,
        fromDate: moment().toISOString(),
        toDate: moment().toISOString(),
        address: this.institution.addresses[0].id,
      }
      this.getVisitTimes(data)
    },
    updateVisitTimes(visitType, date) {
      if (visitType && date) {
        const data = {
          type: visitType,
          address: this.institution.addresses[0].id,
          fromDate: moment(date).toISOString(),
          toDate: moment(date).toISOString(),
        }
        this.getVisitTimes(data)
      }
    },
    isFormValid(visitTime) {
      this.valid = typeof visitTime !== 'undefined'
    },
    ...mapActions({
      getVisitTypes: ACTION_GET_VISIT_TYPES,
      getInstitution: ACTION_GET_DEFAULT_INSTITUTION,
      getVisitTimes: ACTION_GET_VISIT_TIMES,
      bookAppointment: ACTION_BOOK_APPOINTMENT,
    }),
  },
}
</script>

<style lang="stylus" scoped>
.appointment-form {
  height: 100%;
}
</style>
